
/**
 * 페이지 크기
 */
export type SizeParamParameter = number;
